import React, { useEffect, useState } from 'react'
import TaskInnerLeftMenu from './TaskInnerLeftMenu'
import MenuList from './TaskMenu'

const TaskTopLeftContent = () => {

    const MenuItems = MenuList()
    const [component, setComponent] = useState({})

    useEffect(() => {
        const activeComponent = MenuItems.filter((tab, key) => {
            return tab.right === true
        })[0]
        setComponent(activeComponent)
    }, [])

    return (
        <div>
            <TaskInnerLeftMenu subCategKey={component.key}/>
        </div>
    )
}

export default TaskTopLeftContent
